var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileOffers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6875 5H7.20139C4.88495 5 3 7.05631 3 9.58333V22.4167C3 24.9437 4.88495 27 7.20139 27H25.6875C28.0039 27 29.8889 24.9437 29.8889 22.4167V9.58333C29.8889 7.05631 28.0039 5 25.6875 5ZM28.2083 22.4167C28.2083 23.9331 27.0775 25.1667 25.6875 25.1667H7.20139C5.81136 25.1667 4.68056 23.9331 4.68056 22.4167V9.58333C4.68056 8.06694 5.81136 6.83333 7.20139 6.83333H25.6875C27.0775 6.83333 28.2083 8.06694 28.2083 9.58333V22.4167ZM26.2816 11.4536L20.9937 16L26.2816 20.5464C26.6099 20.9045 26.6099 21.4846 26.2816 21.8425C26.1175 22.0215 25.9024 22.1111 25.6875 22.1111C25.4726 22.1111 25.2575 22.0215 25.0934 21.8425L19.8056 17.2962L17.0385 20.3148C16.8745 20.4937 16.6593 20.5833 16.4444 20.5833C16.2295 20.5833 16.0144 20.4937 15.8504 20.3148L13.0833 17.2962L7.79547 21.8425C7.6314 22.0215 7.41629 22.1111 7.20139 22.1111C6.98649 22.1111 6.77138 22.0215 6.60731 21.8425C6.27897 21.4843 6.27897 20.9043 6.60731 20.5464L11.8952 16L6.60731 11.4536C6.27897 11.0955 6.27897 10.5154 6.60731 10.1575C6.93565 9.79951 7.46734 9.79928 7.79547 10.1575L16.4444 18.3705L25.0934 10.1575C25.4218 9.79928 25.9534 9.79928 26.2816 10.1575C26.6097 10.5157 26.6099 11.0957 26.2816 11.4536Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileOffers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-offers.02c1e6b627d8b3f1483cbf73bdeb02f4.svg";